export default __webpack_public_path__ + "static/media/Step1B.9909fd62.svg";